import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { BookOpen, Eye, HeartPulse, Shield, MessageSquare, Map } from 'lucide-react';
export function WhatYouGet() {
  const deliverables = [{
    icon: <BookOpen className="w-8 h-8 text-gold" data-id="element-162" />,
    title: 'El Libro Maestro (PDF)',
    desc: '110 páginas de guía profunda, técnica y compasiva para entender y romper el hechizo.'
  }, {
    icon: <Eye className="w-8 h-8 text-gold" data-id="element-163" />,
    title: 'Inventario de Realidad',
    desc: 'Herramientas para destruir la disonancia cognitiva y ver los hechos sin anestesia.'
  }, {
    icon: <HeartPulse className="w-8 h-8 text-gold" data-id="element-164" />,
    title: 'Diario de Regulación Somática',
    desc: 'Ejercicios diarios para bajar los niveles de cortisol y recuperar la calma física.'
  }, {
    icon: <Shield className="w-8 h-8 text-gold" data-id="element-165" />,
    title: 'Protocolo de Contacto Cero Real',
    desc: 'El paso a paso clínico para protegerte digital y emocionalmente.'
  }, {
    icon: <MessageSquare className="w-8 h-8 text-gold" data-id="element-166" />,
    title: 'Guion de Piedra Gris',
    desc: 'Qué decir y cómo actuar cuando el contacto es inevitable (hijos o trabajo).'
  }, {
    icon: <Map className="w-8 h-8 text-gold" data-id="element-167" />,
    title: 'Hoja de Ruta de Autonomía',
    desc: 'Un plan estructurado de 90 días para reconstruir tu vida desde los cimientos.'
  }];
  return <section className="py-24 px-4 bg-dark-800" data-id="element-168">
      <div className="max-w-6xl mx-auto" data-id="element-169">
        <FadeIn data-id="element-170">
          <h2 className="text-3xl md:text-4xl text-center mb-16" data-id="element-171">
            Lo que recibes hoy
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-172">
          {deliverables.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-173">
              <div className="bg-dark-900 p-8 rounded-xl border border-dark-700 hover:border-gold/40 transition-all duration-300 h-full group" data-id="element-174">
                <div className="mb-6 p-4 bg-dark-800 rounded-lg inline-block group-hover:scale-110 transition-transform duration-300" data-id="element-175">
                  {item.icon}
                </div>
                <h3 className="text-xl mb-3 font-serif text-offwhite" data-id="element-176">
                  {item.title}
                </h3>
                <p className="text-offwhite/70 font-light leading-relaxed" data-id="element-177">
                  {item.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}